@if (status) {
  <div
    [classList]="getClassList()"
    [matContextMenuTriggerFor]="context_menu"
    [matContextMenuTriggerDisabled]="!_canStateReset()"
  [title]="
    status.facilityStatusDisplayText +
    (status.description ? '\r\n\r\n' + status.description : '')
  "></div>
}

<mat-menu #context_menu>
  <button mat-menu-item (click)="_onStateReset()">
    <mat-icon>backspace
    </mat-icon>
    <span>Status zurücksetzen</span>
  </button>
</mat-menu>